/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * 
 * @export
 * @interface GetProducts200ResponseAllOfData
 */
export interface GetProducts200ResponseAllOfData {
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetProducts200ResponseAllOfData
     */
    products: Array<Product>;
}

/**
 * Check if a given object implements the GetProducts200ResponseAllOfData interface.
 */
export function instanceOfGetProducts200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

export function GetProducts200ResponseAllOfDataFromJSON(json: any): GetProducts200ResponseAllOfData {
    return GetProducts200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetProducts200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(ProductFromJSON)),
    };
}

export function GetProducts200ResponseAllOfDataToJSON(value?: GetProducts200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'products': ((value.products as Array<any>).map(ProductToJSON)),
    };
}

